import {Component} from '@angular/core';
import {ItemAtendimento, ListaAtendimento} from "../../models/lista-atendimento";
import {AtendimentoService} from "../../services/atendimento.service";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrl: './lista.component.css',
  standalone: false
})
export class ListaComponent {
  loading = true;
  public colunas = ['#', `Solicitante`, 'Valor Previsto', 'Descrição', 'Status', 'Data'];
  public linhas: any[] = [];
  listaAtendimento = new ListaAtendimento();
  lista = false;
  showModal = false;
  showModalCompromisso = false;
  showModalCliente = false;
  paginaAtual=1;

  constructor(private atendimentoService: AtendimentoService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.buscarListaAtendimentos();

  }

  fecharModal() {
    this.showModalCliente = false;
    this.showModal = false;
    this.showModalCompromisso = false;
    this.buscarListaAtendimentos();
  }

  deletar(id: number){

  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  preencherLinhaTabela(listaItens: ItemAtendimento[]) {
    for (let item of listaItens) {
      let stringArray: string[] = [];
      stringArray.push(item.id.toString(), item.solicitante, 'R$ ' + item.valor?.toString(), item.descricaoResumida, item.statusDescricao, <string>this.datePipe.transform(item.dataCadastro, 'dd/MM/yyyy'));
      this.linhas.push(stringArray);
    }
  }

  private buscarListaAtendimentos() {
    this.atendimentoService.selecionarLista().subscribe(
      response => {
        this.listaAtendimento = response.dados;
        this.preencherLinhaTabela(this.listaAtendimento.itens);
        this.loading = false;
      }
    );
  }

}
